import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "disabled-arrow",
  "use": "disabled-arrow-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"disabled-arrow\">\n<g id=\"disabled-arrow_arrow / drop_left 2\">\n<path id=\"disabled-arrow_Vector\" d=\"M8.00016 7.41L9.41016 6L15.4102 12L9.41015 18L8.00015 16.59L12.5802 12L8.00016 7.41Z\" fill=\"#E0E0E0\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol